<template>
   <v-container fluid class="fill-height">
      <v-row justify="center">
         <v-col class="text-center">
            <h1 class="text-h4 mb-4">Carregando canais</h1>
            <v-progress-circular indeterminate></v-progress-circular>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
   computed: {
      ...mapGetters('rasaServices', [
         'services',
      ]),
   },

   created() {
      this.goToService(this.services)
   },

   methods: {
      goToService(services) {
         if (services.length == 0) {
            return
         }

         let service = services[0]

         console.log('Redirecionando para ', service.type)

         this.$router.push({
            name: 'cs2_loadingPage',
            params: {
               service_type: service.type,
            },
         })
      },
   },

   watch: {
      services: 'goToService',
   },
};
</script>

<style>
   /* .backgroud {
        background: #f1f1f1;
        color: #08977E;
        height: 100vh;
    } */
</style>
